import * as React from 'react';
import { EVertical } from '../../utils';
import { FormBanner, SuccessModal } from '@cian/demand-trap-widget';
import {
  EPriorityCommunicationChannel,
  ICreateMessageForOfferRequest,
} from '../../../../repositories/demand/v2/create-message-for-offer';
import { ElementInViewport } from '../../../../common/components/elementInViewport';

export interface IDemandFormData {
  name: string;
  email: string;
  phone: string;
  companyName?: string;
  isHomeowner?: boolean;
  hasAgentProfile?: boolean;
  priorityCommunicationChannel?: EPriorityCommunicationChannel;
}

export interface ITrapProps {
  offerId: number;
  disclaimerText: string;
  disclaimerHeader: string;
  isSuccessModalOpen: boolean;
  vertical: EVertical;
  name?: string;
  email?: string;
  phone?: string;
  displayName?: string;
  isAuthenticated?: boolean;
  containerRef?: React.RefObject<HTMLDivElement>;
  observerKey?: string | number;
  userId: string;
  abGroup: string;
  soprApi: string;

  demandRequestCreateMessageStartAction(data: ICreateMessageForOfferRequest): void;

  demandCloseSuccessModalAction(): void;

  onShownInViewPort(visible: boolean): void;
}

export class Trap extends React.Component<ITrapProps> {
  private isBannerVisibleTrackDone = false;

  public render() {
    const {
      disclaimerHeader,
      disclaimerText,
      vertical,
      isAuthenticated,
      name,
      phone,
      email,
      isSuccessModalOpen,
      demandCloseSuccessModalAction,
      containerRef,
    } = this.props;

    return (
      <div ref={containerRef}>
        <ElementInViewport onChange={this.handleTrapShowInViewport}>
          <FormBanner
            name={name}
            email={email}
            phone={phone}
            vertical={vertical}
            disclaimerText={disclaimerText}
            isAuthenticated={isAuthenticated}
            disclaimerHeader={disclaimerHeader}
            createMessage={this.handleFormSubmit}
          />
        </ElementInViewport>

        {isSuccessModalOpen && <SuccessModal onCloseClick={demandCloseSuccessModalAction} />}
      </div>
    );
  }

  private handleTrapShowInViewport = (visible: boolean) => {
    if (visible && !this.isBannerVisibleTrackDone) {
      this.props.onShownInViewPort(visible);
      this.isBannerVisibleTrackDone = true;
    }
  };

  private handleFormSubmit = (formData: IDemandFormData) => {
    const { demandRequestCreateMessageStartAction, offerId } = this.props;

    const parameters: ICreateMessageForOfferRequest = {
      companyName: formData.companyName,
      email: formData.email,
      fullName: formData.name,
      hasAgentProfile: formData.hasAgentProfile,
      isHomeowner: formData.isHomeowner,
      offerId,
      phone: formData.phone,
      priorityCommunicationChannel: formData.priorityCommunicationChannel,
      source: 'Card',
    };

    demandRequestCreateMessageStartAction(parameters);
  };
}
